export const upgradeKinds = [
  "MaxCores",
  "OverchargedCore",
  "CoreValue",
  "ChargeBonus",
  "ShellSpeed",
  "GateWidth",
  "GateCount",
  "ExtraShell",
  "CollectorAmp",
  "CriticalDischarge",
  "OfflineReactor",
  "PolaritySync",
  "ShellLens"
] as const;

export type UpgradeKind = (typeof upgradeKinds)[number];

export interface UpgradeDefinition {
  readonly kind: UpgradeKind;
  readonly label: string;
  readonly basePrice: number;
  readonly growth: number;
  readonly unlockLevel: number;
  readonly maxLevel: number;
}

export type UpgradeLevels = Record<UpgradeKind, number>;

export const upgradePanelOrder: readonly UpgradeKind[] = [
  "MaxCores",
  "CoreValue",
  "ChargeBonus",
  "ShellSpeed",
  "GateWidth",
  "GateCount",
  "ExtraShell",
  "CollectorAmp",
  "OverchargedCore",
  "PolaritySync",
  "CriticalDischarge",
  "OfflineReactor",
  "ShellLens"
];

export const upgradeDefinitions: readonly UpgradeDefinition[] = [
  { kind: "MaxCores", label: "Max Cores", basePrice: 115, growth: 1.62, unlockLevel: 1, maxLevel: 48 },
  { kind: "OverchargedCore", label: "Overcharged Cores", basePrice: 39_000, growth: 1.31, unlockLevel: 6, maxLevel: 200 },
  { kind: "CoreValue", label: "Value", basePrice: 55, growth: 1.25, unlockLevel: 1, maxLevel: 200 },
  { kind: "ChargeBonus", label: "Bounce Reward", basePrice: 90, growth: 1.27, unlockLevel: 1, maxLevel: 200 },
  { kind: "ShellSpeed", label: "Shell Speed", basePrice: 360, growth: 1.42, unlockLevel: 1, maxLevel: 32 },
  { kind: "GateWidth", label: "Gate Width", basePrice: 950, growth: 1.62, unlockLevel: 1, maxLevel: 18 },
  { kind: "GateCount", label: "Gates", basePrice: 5_000, growth: 8, unlockLevel: 1, maxLevel: 3 },
  { kind: "ExtraShell", label: "Shells", basePrice: 30_000, growth: 35, unlockLevel: 1, maxLevel: 2 },
  { kind: "CollectorAmp", label: "Collector Amp", basePrice: 1_200, growth: 1.29, unlockLevel: 3, maxLevel: 200 },
  { kind: "CriticalDischarge", label: "Critical Discharge", basePrice: 85_000, growth: 1.34, unlockLevel: 8, maxLevel: 200 },
  { kind: "OfflineReactor", label: "Offline Reactor", basePrice: 220_000, growth: 1.38, unlockLevel: 10, maxLevel: 200 },
  { kind: "PolaritySync", label: "Polarity Sync", basePrice: 180_000, growth: 1.33, unlockLevel: 7, maxLevel: 200 },
  { kind: "ShellLens", label: "Shell Lens", basePrice: 480_000, growth: 1.36, unlockLevel: 12, maxLevel: 80 }
];

export function getUpgradeDefinition(kind: UpgradeKind): UpgradeDefinition {
  const definition = upgradeDefinitions.find((entry) => entry.kind === kind);
  if (!definition) {
    throw new Error(`Unknown upgrade kind: ${kind}`);
  }
  return definition;
}

export function createEmptyUpgradeLevels(): UpgradeLevels {
  return Object.fromEntries(upgradeKinds.map((kind) => [kind, 0])) as UpgradeLevels;
}
